import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const WarehouseOrderPage = lazy(
  () =>
    import("../../../../../components/WMS/WarehouseOrders/WarehouseOrderPage"),
)

export const Route = createFileRoute(
  "/_layout/WMS/documents/warehouse-orders/$warehouseOrder",
)({
  validateSearch: (search: Record<string, unknown>) => {
    const res: { tab?: "general" | "info" | "files"; edit?: number } = {}
    if (
      search.tab === "general" ||
      search.tab === "info" ||
      search.tab === "files"
    ) {
      res.tab = search.tab
    }
    if (search.edit === 1 || search.edit === "1") {
      res.edit = 1
    }
    return res
  },
  component: WarehouseOrderRoute,
})

function WarehouseOrderRoute() {
  return (
    <LazyRoutePage>
      <WarehouseOrderPage />
    </LazyRoutePage>
  )
}
